import React from 'react';
import { motion } from 'motion/react';
import { FiGithub, FiLinkedin, FiTwitter, FiMail } from 'react-icons/fi';
import styles from './SocialRail.module.css';

const railVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1],
      delay: 1.5,
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

function SocialRail() {
  const socials = [
    { icon: FiGithub, url: 'https://github.com/balaram753', label: 'GitHub' },
    { icon: FiLinkedin, url: 'https://linkedin.com/in/chbalaram', label: 'LinkedIn' },
    { icon: FiTwitter, url: 'https://twitter.com/balaram753', label: 'Twitter' },
    { icon: FiMail, url: 'mailto:hello@balaram.me', label: 'Email' },
  ];

  return (
    <motion.div
      className={styles.rail}
      variants={railVariants}
      initial="hidden"
      animate="visible"
    >
      <div className={styles.icons}>
        {socials.map((social, idx) => {
          const Icon = social.icon;
          return (
            <motion.a
              key={idx}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
              aria-label={social.label}
              variants={itemVariants}
              whileHover={{ y: -3, color: 'var(--text-primary)' }}
            >
              <Icon size={18} />
            </motion.a>
          );
        })}
      </div>
      <div className={styles.line} />
    </motion.div>
  );
}

export default SocialRail;
